import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { Container } from "@mui/material"

import ProjectForm from "./ProjectForm"
import Navbar from "../CommonC/SelexSolNavbar";
import { baseURL } from "../../Config/config";


function AdminAddProject(){

const navigate = useNavigate()

const [project,setProject] = useState({
title:"",
slug:"",
description:"",
author:"",
image:"",
content:""
})


const submit = async ()=>{

  const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(project),
      };
      try {
        let res = await fetch(`${baseURL}/addoptimizeproject`, requestOptions);
        res = await res.json();
        if (res.code) {
          navigate("/adminhome")
          return;
        }
        alert("Some Error");
      } catch (error) {
        alert("Some Error", error);
        console.log("err", error);
      }

}

return(

    <div
        style={{
          height:window.screen.height
        }}
      >
       
        <Navbar admin={true}/>

<Container sx={{background:"white", maxHeight: "750px",overflowY: "auto",marginTop:"15px",padding:"10px"}}>

<ProjectForm
project={project}
setProject={setProject}
onSubmit={submit}
/>

</Container>
</div>

)

}

export default AdminAddProject